import {AuthorityType} from "./authorityType.model";
import {SvedClientType} from "./svedClientType.model";

export class SvedPredstInfoType extends SvedClientType {
  authority: AuthorityType = new AuthorityType();
}
